import axios from "axios";
import { useLayoutStore } from "@/stores/layoutStore.js";

// HWM(생활폐기물 통합관리) 공개 API 전용 인스턴스.
// 무토큰 공개 API라 Authorization 헤더를 붙이지 않고 401 refresh도 하지 않는다.
// Content-Type을 강제하지 않아야 파일 업로드(multipart) boundary가 유지된다.
const { VITE_HWM_API_BASE_URL } = import.meta.env;
const hwmAxios = axios.create({
  timeout: 30000,
});
hwmAxios.defaults.baseURL = VITE_HWM_API_BASE_URL;

hwmAxios.interceptors.request.use(
  function (config) {
    console.log("############################");
    console.log(`request url : ${config.url}`);
    console.log(`request method : ${config.method}`);
    if (config.data !== undefined) {
      console.log(`request body : `);
      console.log(config.data);
    }

    if (config.params !== undefined) {
      console.log(`request parameter : `);
      console.log(config.params);
    }

    console.log("############################");
    // 요청 전에 로딩 오버레이 띄우기
    const loadingStore = useLayoutStore();
    loadingStore.showOverlay();

    return config;
  },
  function (error) {
    // 에러 나면 로딩 끄기
    const loadingStore = useLayoutStore();
    loadingStore.hideOverlay();
    return Promise.reject(error);
  },
);

// 응답 인터셉터
hwmAxios.interceptors.response.use(
  function (response) {
    console.log("############################");
    console.log(`response url : ${response.config.url}`);
    console.log(`response data : `);
    if (window.flutter_inappwebview) {
      console.log(JSON.stringify(response.data));
    } else {
      console.log(response.data);
    }

    console.log("############################");
    // 응답 받으면 로딩 끄기
    const loadingStore = useLayoutStore();
    loadingStore.hideOverlay();

    return response;
  },
  function (error) {
    const loadingStore = useLayoutStore();
    loadingStore.hideOverlay();
    return Promise.reject(error);
  },
);

// HWM 에러 응답(drf-standardized-errors 봉투)을 표시용으로 파싱한다.
// 400: {type:"validation_error", errors:[{code, detail, attr}]}
// 403(인증번호 불일치)/429(요청 초과)도 같은 봉투를 쓴다.
export function getHwmError(error) {
  const status = error?.response?.status ?? null;
  const first = error?.response?.data?.errors?.[0] ?? {};
  return {
    status,
    code: first.code ?? null,
    attr: first.attr ?? null,
    detail: first.detail ?? null,
  };
}

export default hwmAxios;
